module.exports = __webpack_public_path__ + "media/images/flextab-logo-3e8bf7a659f9b643f26542a36056ac35.png";